import { render, staticRenderFns } from "./SilenciarCategoria.vue?vue&type=template&id=9e048dbc"
import script from "./SilenciarCategoria.vue?vue&type=script&lang=js"
export * from "./SilenciarCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports